/* Fantastick Produktinfos 1.0.0 | Read-only; no cart/checkout/fetch/history overrides. */
(function () {
  'use strict';
  if (window.FantastickProductInfo) {
    window.FantastickProductInfo.init();
    return;
  }
  const VERSION = '1.0.0';
  const DAY = 86400000;
  const instances = new Set();
  const holidays = new Map();
  let cart = null;
  let cartVerified = true;
  let cartUrl = '';
  let refreshPromise = null;
  let refreshAgain = false;
  let refreshTimer;
  let refreshDue = false;
  let lastRefresh = 0;

  function iso(day) { return new Date(day).toISOString().slice(0, 10); }
  function parseDay(value) {
    const s = String(value || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
    const t = Date.parse(s + 'T12:00:00Z');
    return Number.isFinite(t) && iso(t) === s && +s.slice(0, 4) >= 2000 ? t : null;
  }
  function berlinDay(now) {
    try {
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date(now == null ? Date.now() : now));
      const p = Object.fromEntries(parts.map(part => [part.type, part.value]));
      return parseDay(p.year + '-' + p.month + '-' + p.day);
    } catch (_) { return null; }
  }
  function easter(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1, 12);
  }
  function holidaySet(year, region) {
    const key = year + ':' + region;
    if (holidays.has(key)) return holidays.get(key);
    const set = new Set();
    if (region === 'DE' || region === 'DE-BW') {
      const dates = ['01-01', '05-01', '10-03', '12-25', '12-26'];
      if (region === 'DE-BW') dates.push('01-06', '11-01');
      dates.forEach(day => set.add(year + '-' + day));
      const base = easter(year);
      [-2, 1, 39, 50].concat(region === 'DE-BW' ? [60] : []).forEach(offset => set.add(iso(base + offset * DAY)));
    }
    holidays.set(key, set);
    return set;
  }
  function parseClosures(text) {
    const ranges = [];
    let valid = true;
    String(text || '').split(/\r?\n|,/).forEach(line => {
      if (!line.trim()) return;
      const dates = line.trim().split('/');
      const from = parseDay(dates[0]), until = parseDay(dates[1] || dates[0]);
      if (dates.length > 2 || from === null || until === null || from > until) { valid = false; return; }
      ranges.push([from, until]);
    });
    return {ranges, valid};
  }
  function isWorkingDay(day, config, ranges) {
    return new Date(day).getUTCDay() !== 0 &&
      !holidaySet(new Date(day).getUTCFullYear(), config.holidayRegion).has(iso(day)) &&
      !ranges.some(range => day >= range[0] && day <= range[1]);
  }
  function deliveryRange(config, variant, now) {
    const start = berlinDay(now);
    const closed = parseClosures(config.closedDays);
    if (start === null || !closed.valid || !Number.isInteger(variant.min) || !Number.isInteger(variant.max) || variant.min < 1 || variant.max < variant.min || variant.max > 90) return null;
    let count = 0, day = start, from = null, until = null;
    // Order day is excluded. The cap also handles accidentally multi-year closures.
    for (let n = 0; n < 1100 && count < variant.max; n++) {
      day += DAY;
      if (!isWorkingDay(day, config, closed.ranges)) continue;
      count++;
      if (count === variant.min) from = day;
      if (count === variant.max) until = day;
    }
    return from !== null && until !== null ? {from, until} : null;
  }
  function formatDay(day, year) {
    return new Intl.DateTimeFormat('de-DE', {timeZone: 'UTC', weekday: 'short', day: '2-digit', month: '2-digit', ...(year ? {year: 'numeric'} : {})}).format(new Date(day));
  }
  function thresholdCents(value) {
    const s = String(value == null ? '' : value).trim().replace(',', '.');
    if (!/^\d+(?:\.\d{1,2})?$/.test(s)) return null;
    const cents = Math.round(Number(s) * 100);
    return Number.isSafeInteger(cents) && cents >= 0 ? cents : null;
  }
  function money(cents, currency) {
    try { return new Intl.NumberFormat('de-DE', {style: 'currency', currency}).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2).replace('.', ',') + ' ' + currency; }
  }
  function normaliseCart(value) {
    if (!value || !Number.isSafeInteger(value.total) || value.total < 0 || !Number.isInteger(value.count) || value.count < 0 || typeof value.hasException !== 'boolean' || !/^[A-Z]{3}$/.test(value.currency)) throw new Error('Invalid cart snapshot');
    if (typeof value.discounted !== 'boolean' || !Array.isArray(value.productIds)) throw new Error('Invalid cart items');
    return {total: value.total, count: value.count, currency: value.currency, hasException: value.hasException, discounted: value.discounted, productIds: value.productIds.map(String)};
  }
  function shippingState(config, variant, quantity, snapshot, verified) {
    const minimum = thresholdCents(config.threshold);
    const generic = {type: 'generic', main: 'zzgl. Versandkosten', detail: 'Die Kosten werden anhand der Lieferadresse an der Kasse berechnet.'};
    if (!variant || !variant.available || variant.shipping === false || !verified || !config.freeEnabled || config.shippingException || minimum === null || !snapshot || snapshot.hasException || config.currency !== config.ruleCurrency || snapshot.currency !== config.currency || !(config.freeCountries || []).includes(config.country)) return generic;
    const scope = 'nach ' + config.countryName;
    const condition = 'Ab ' + money(minimum, config.currency) + ' Bestellwert nach Rabatten.';
    const selected = Number.isSafeInteger(variant.price) && variant.price >= 0 ? variant.price * quantity : 0;
    if (snapshot.total >= minimum && (snapshot.count > 0 || minimum === 0)) {
      return {type: 'free', main: 'Standardversand ' + scope + ': ' + money(0, config.currency), detail: 'Dein Warenkorb erreicht die Freigrenze. ' + condition};
    }
    if (!snapshot.discounted && !snapshot.productIds.includes(String(config.productId)) && selected >= minimum) {
      return {type: 'free', main: 'Standardversand ' + scope + ': ' + money(0, config.currency), detail: 'Diese Auswahl erreicht die Freigrenze. ' + condition};
    }
    const detail = snapshot.count > 0
      ? 'Noch ' + money(Math.max(0, minimum - snapshot.total), config.currency) + ' im Warenkorb bis zum kostenlosen Standardversand ' + scope + '.'
      : 'Kostenloser Standardversand ' + scope + ' ab ' + money(minimum, config.currency) + ' Bestellwert nach Rabatten.';
    return {...generic, detail};
  }
  function write(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  class ProductInfo {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-fpi-config]').textContent);
      this.variants = new Map((this.config.variants || []).map(v => [String(v.id), v]));
      this.id = String(this.config.selectedId || '');
      this.hint = null;
      this.scope = document.getElementById('shopify-section-' + this.config.sectionId) || root.closest('.shopify-section') || root.parentElement;
      this.last = '';
      if (cart === null) cart = normaliseCart(this.config.cart);
      if (!cartUrl) cartUrl = this.config.cartStateUrl;
      root._fpiInstance = this;
      this.update();
    }
    selection() {
      // Product inputs are read only within this section; unrelated quick-adds cannot change it.
      const forms = [...this.scope.querySelectorAll('form[action*="/cart/add"]')].filter(form => !String(form.id).includes('installment'));
      const candidates = forms.length ? forms.flatMap(form => [...form.querySelectorAll('[name="id"]')]) : this.scope.querySelectorAll('input[name="id"], select[name="id"]');
      let selected = null;
      for (const input of candidates) {
        if (input.type === 'radio' && !input.checked) continue;
        if (input.value) { selected = input; break; }
      }
      if (this.hint && selected && String(selected.value) === this.hint.id) this.hint = null;
      if (this.hint && this.hint.until > Date.now()) this.id = this.hint.id;
      else {
        this.hint = null;
        if (selected) this.id = String(selected.value);
      }
      const owner = selected && selected.form;
      const quantity = (owner && owner.querySelector('[name="quantity"]')) || this.scope.querySelector('[name="quantity"]');
      const raw = Number(quantity && quantity.value || 1);
      return {variant: this.variants.get(this.id), quantity: Number.isInteger(raw) && raw >= 1 && raw <= 100000 ? raw : 1};
    }
    acceptVariant(event) {
      const data = event.detail || event.data || {};
      const variant = data.variant || data.data && data.data.variant || data.resource;
      const id = variant && variant.id;
      if (id != null && this.variants.has(String(id))) {
        this.hint = {id: String(id), until: Date.now() + 2500};
        this.id = String(id);
        this.update(true);
      }
    }
    update(force) {
      if (!this.root.isConnected) { instances.delete(this); return; }
      const selection = this.selection();
      const variant = selection.variant;
      const stamp = JSON.stringify([this.id, selection.quantity, cart, cartVerified, berlinDay()]);
      if (!force && stamp === this.last) return;
      this.last = stamp;
      this.root.hidden = !!variant && variant.shipping === false;
      if (this.config.view === 'delivery') this.delivery(variant);
      else this.shipping(variant, selection.quantity);
    }
    shipping(variant, quantity) {
      const state = shippingState(this.config, variant, quantity, cart, cartVerified);
      const line = this.root.querySelector('[data-fpi-shipping-main]');
      const detail = this.root.querySelector('[data-fpi-shipping-detail]');
      const check = this.root.querySelector('[data-fpi-check]');
      const policy = this.root.querySelector('[data-fpi-policy]');
      this.root.querySelector('.fpi__shipping').classList.toggle('is-free', state.type === 'free');
      check.toggleAttribute('hidden', state.type !== 'free');
      policy.hidden = state.type !== 'free' || !this.config.policyUrl;
      if (state.type === 'generic' && this.config.policyUrl) {
        if (!line.querySelector('a')) {
          const link = document.createElement('a');
          link.href = this.config.policyUrl;
          link.textContent = 'Versandkosten';
          line.replaceChildren(document.createTextNode('zzgl. '), link);
        }
      } else write(line, state.main);
      write(detail, state.detail);
    }
    delivery(variant) {
      const heading = this.root.querySelector('[data-fpi-heading]');
      const dates = this.root.querySelector('[data-fpi-dates]');
      const detail = this.root.querySelector('[data-fpi-delivery-detail]');
      const note = this.root.querySelector('[data-fpi-delivery-note]');
      note.hidden = true;
      write(heading, 'Voraussichtlich bei dir');
      if (!variant) {
        write(dates, 'Bitte eine Variante auswählen');
        write(detail, 'Die Lieferzeit wird nach der Auswahl angezeigt.');
        return;
      }
      if (!variant.available) {
        write(dates, 'Derzeit nicht verfügbar');
        write(detail, 'Für diese Auswahl kann aktuell kein Liefertermin angegeben werden.');
        return;
      }
      if (!(this.config.deliveryCountries || []).includes(this.config.country)) {
        write(heading, 'Lieferung nach ' + this.config.countryName);
        write(dates, 'Lieferzeit abhängig vom Lieferland');
        write(detail, 'Die Angaben für dein Lieferland findest du in den Versandbedingungen.');
        return;
      }
      const range = deliveryRange(this.config, variant);
      if (!range) {
        write(dates, 'Liefertermin auf Anfrage');
        write(detail, 'Den aktuellen Lieferzeitraum teilen wir dir gerne mit.');
        return;
      }
      const year = new Date(range.from).getUTCFullYear() !== new Date(range.until).getUTCFullYear() || new Date(range.from).getUTCFullYear() !== new Date(berlinDay()).getUTCFullYear();
      write(dates, formatDay(range.from, year) + ' – ' + formatDay(range.until, year));
      const calendar = this.config.holidayRegion === 'none' ? 'Mo.–Sa.' : 'Mo.–Sa., ohne Feiertage';
      write(detail, 'Lieferzeit: ca. ' + variant.min + '–' + variant.max + ' Werktage (' + calendar + ') bei Bestellung heute.');
      const start = berlinDay();
      const closures = parseClosures(this.config.closedDays).ranges;
      if (closures.some(r => r[1] >= start && r[0] <= range.until)) {
        write(note, 'Unsere Schließtage sind im angezeigten Zeitraum bereits berücksichtigt.');
        note.hidden = false;
      }
    }
  }
  function updateAll(force) { instances.forEach(instance => instance.update(force)); }
  function init(scope) {
    const target = scope && scope.querySelectorAll ? scope : document;
    const roots = [...target.querySelectorAll('[data-fpi-root]')];
    if (target.matches && target.matches('[data-fpi-root]')) roots.unshift(target);
    roots.forEach(root => {
      if (root._fpiInstance) return;
      try { instances.add(new ProductInfo(root)); }
      catch (_) { root.dataset.fpiError = 'config'; }
    });
  }
  async function refresh() {
    if (!cartUrl || !instances.size) return;
    if (refreshPromise) { refreshAgain = true; return refreshPromise; }
    refreshPromise = (async () => {
      try {
        const url = new URL(cartUrl, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid cart URL');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        let response;
        try { response = await fetch(url.href, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: {'Accept': 'text/html'}}); }
        finally { clearTimeout(timeout); }
        if (!response.ok) throw new Error('Cart section unavailable');
        const html = await response.text();
        const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-fpi-cart-state]');
        cart = normaliseCart(JSON.parse(node.textContent));
        cartVerified = true;
      } catch (_) { cartVerified = false; }
      lastRefresh = Date.now();
      updateAll(true);
    })();
    try { await refreshPromise; }
    finally {
      refreshPromise = null;
      if (refreshAgain) { refreshAgain = false; scheduleRefresh(); }
    }
  }
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    if (document.hidden) { refreshDue = true; return; }
    refreshTimer = setTimeout(refresh, 180);
  }
  function inputUpdate() { setTimeout(() => updateAll(true), 0); }
  window.FantastickProductInfo = {
    version: VERSION, init, refresh,
    calendar: {berlinDay, parseDay, parseClosures, deliveryRange, holidaySet},
    shippingState, thresholdCents
  };
  init();
  refresh();
  document.addEventListener('change', inputUpdate);
  document.addEventListener('input', inputUpdate);
  ['variant:change', 'variant:changed', 'variant:update', 'variant:selected', 'product:variant-change'].forEach(type => {
    document.addEventListener(type, event => { instances.forEach(i => i.acceptVariant(event)); inputUpdate(); });
  });
  ['cart:updated', 'cart:update', 'cart:refresh', 'cart:change', 'cart:changed', 'cart:item-added', 'product:added'].forEach(type => document.addEventListener(type, scheduleRefresh));
  document.addEventListener('shopify:section:load', event => { init(event.target); updateAll(true); scheduleRefresh(); });
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach(i => { if (event.target.contains(i.root)) { instances.delete(i); delete i.root._fpiInstance; } });
  });
  window.addEventListener('pageshow', () => { init(); updateAll(true); scheduleRefresh(); });
  window.addEventListener('focus', scheduleRefresh);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) { updateAll(true); if (refreshDue || Date.now() - lastRefresh > 10000) scheduleRefresh(); refreshDue = false; }
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length || record.removedNodes.length)) {
      // Child changes are common with Shopify section rendering; init only new roots.
      records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) init(node); }));
      instances.forEach(i => { if (!i.root.isConnected) instances.delete(i); });
    }
  });
  observer.observe(document.documentElement, {childList: true, subtree: true});
  try {
    const resources = new PerformanceObserver(list => {
      if (list.getEntries().some(entry => {
        try {
          const url = new URL(entry.name);
          return url.origin === location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
        } catch (_) { return false; }
      })) scheduleRefresh();
    });
    resources.observe({type: 'resource', buffered: true});
  } catch (_) { /* Theme cart events and visible-page polling remain available. */ }
  // Detect themes updating only input.value, and recover missed cart events.
  setInterval(() => {
    if (document.hidden || !instances.size) return;
    updateAll();
    if (!refreshPromise && Date.now() - lastRefresh > 30000) scheduleRefresh();
  }, 1000);
})();
